import { useTranslation } from "react-i18next";
import styled from "styled-components";

const Container = styled.div`
  padding: 0 15px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
`;

const Description = styled.div`
  color: #69707f;

  font-size: 18px;
  margin: 20px 0px 40px 0px;
`;

const Card = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.07);
  padding: 15px 0px 0px 15px;
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
`;
const TopBlock = styled.div`
  display: flex;

  align-items: center;
`;

const Icon = styled.img<{ width: number; height: number }>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  margin-right: 15px;
`;

const RightBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

const CenterText = styled.div`
  color: #69707f;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16px;
`;
const Text = styled.div`
  color: #69707f;
  font-size: 16px;
  margin-bottom: 16px;
  font-weight: 400;
`;

const FeedBackText = styled.a`
  color: #0034a4;
  font-size: 16px;
  margin-bottom: 16px;
  font-weight: 400;
  text-decoration-line: none;
`;

const SeeMoreText = styled(FeedBackText)`
  font-size: 12px;

  align-self: flex-end;
  margin-right: 10px;
`;

const partnerArray = [
  {
    tel: "(+886)2-2182-1313",
    telLink: "+886-02-2182-1313",
    feedBackLink:
      "https://www.esunbank.com/zh-tw/about/services/customer/message-board",
    image: "esun.png",
    opTime: "esun_op_time",
    width: 89,
    height: 26,
    seeMoreLink: "https://esun.co/mmJwk",
  },

  {
    tel: "(+886)2-2278-5200",
    telLink: "+886-02-2278-5200",
    email: "service@pxpayplus.com",
    image: "pxp.png",
    opTime: "pxp_op_time",
    width: 89,
    height: 38,
    seeMoreLink:
      "https://www.pxpayplus.com/FAQ/%E5%A2%83%E5%A4%96%E4%BA%A4%E6%98%93",
  },
  {
    tel: "(+886)2-8771-7212",
    telLink: "+886-02-8771-7212",
    email: "service@jkopay.com",
    image: "jko.png",
    opTime: "jko_op_time",
    feedBackLink: undefined,
    width: 90,
    height: 50,
    seeMoreLink: "https://mkt.jkopay.com/event/paypaylogo",
  },
];

const Support = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Description>{t("description")}</Description>
      {partnerArray.map((partner) => {
        return (
          <Card key={partner.opTime}>
            <TopBlock>
              <Icon
                width={partner.width}
                height={partner.height}
                src={`${process.env.PUBLIC_URL}/${partner.image}`}
              />
              <RightBlock>
                <CenterText>{t("customer_center")}</CenterText>
                <Text>
                  Tel:
                  <br />
                  <FeedBackText href={`tel:${partner.tel}`}>
                    {partner.tel}
                  </FeedBackText>
                </Text>
                {partner.email && (
                  <Text>
                    Email:
                    <br />
                    <FeedBackText href={`mailto:${partner.email}`}>
                      {partner.email}
                    </FeedBackText>
                  </Text>
                )}
                {partner?.feedBackLink && (
                  <FeedBackText href={partner?.feedBackLink} target="_blank">
                    {t("board")}
                  </FeedBackText>
                )}
                <Text>
                  {t("operation_time")}
                  <br /> {t(partner.opTime)}
                </Text>
              </RightBlock>
            </TopBlock>
            <SeeMoreText href={partner.seeMoreLink} target="_blank">
              {t("see_more")}
            </SeeMoreText>
          </Card>
        );
      })}
    </Container>
  );
};
export default Support;
